// Auto-generated by scripts/writeBuildMeta.js — do not edit manually.

export const SCHEDULES_BUILD_META = Object.freeze({
  "version": "1.0.0",
  "commitFull": "e5efd6a6a19984768b94250cb662914496a9a9e1",
  "commitPreview": "e5efd6a",
  "tag": "November 2026",
  "built": "2026-11-04 17:23 EST"
});

export function getSchedulesVersionParts() {
  return { ...SCHEDULES_BUILD_META };
}
